export const BILLING_PATH = 'billing';
export const BILLING_PAGE = `/${BILLING_PATH}`;
